class ContainerFacade {
  _container;
  constructor(container) {
    this._container = container;
  }
}
export {
  ContainerFacade
};
//# sourceMappingURL=containerFacade.js.map
